module.exports = __webpack_public_path__ + "5dc76a4a0f7d1464dbc6e5ec79402284.png";